/**
 * messageRenderers — renderer map for media message types.
 *
 * MessageBubble dispatches media content through this map instead of an
 * inline if-chain, so new message types (image_album, video, location,
 * event, ...) register here without touching the bubble.
 *
 * Each renderer receives { media, isOwn } and renders inside the bubble.
 * A type with no entry renders nothing (text-only path).
 *
 * @module features/messaging/components/messageRenderers
 */

import { MESSAGE_TYPES } from '@/models/Conversation';
import ImageMessage from './ImageMessage';
import FileMessage from './FileMessage';
import VoiceMessage from './VoiceMessage';

export const messageRenderers = {
  [MESSAGE_TYPES.IMAGE]: ImageMessage,
  [MESSAGE_TYPES.FILE]: FileMessage,
  [MESSAGE_TYPES.VOICE]: VoiceMessage,
  // Thread A types (IMAGE_ALBUM, VIDEO, LOCATION, EVENT) register here
  // as their renderers are built.
};

/**
 * @param {string} type - message.type
 * @returns {React.ComponentType|null} renderer for the type's media, or null
 */
export function getMediaRenderer(type) {
  return messageRenderers[type] || null;
}

export default messageRenderers;
